document.addEventListener('DOMContentLoaded', function () {
  console.log('Script executed');

  const currentDate = new Date();
  const targetedPosts = document.querySelectorAll('.smc-loop-item.smc-loop--dates');

  targetedPosts.forEach(post => {
    const timeElement = post.querySelector('time');

    if (timeElement) {
      const publishDateAttribute = timeElement.getAttribute('datetime');

      if (publishDateAttribute) {
        const publishDate = new Date(publishDateAttribute);

        // Add one year to the publish date
        publishDate.setFullYear(publishDate.getFullYear() + 1, publishDate.getMonth(), publishDate.getDate() + 1);

        console.log('Publish Date:', publishDate);

        // Compare the adjusted publish date with the current date
        if (publishDate < currentDate) {
          // Unload the post by removing it from the DOM
          post.remove();
          console.log('Unloading post:', post);
        }
      } else {
        console.error('Datetime attribute not found in time element:', timeElement);
      }
    } else {
      console.error('Could not find time element in post:', post);
    }
  });
});